<template>
  <div id="main-content">
    <router-link to="/about">
      <div class="p-5 mb-4 hbtn-lightgray rounded-3 hbtn-bg-1" role="button">
        <div class="container-fluid py-4 div-jumbotron">
          <div class="col">
            <h1 class="">About</h1>
            <p class="jmb-subtitle">General Information</p>
          </div>

          <div class="jumbotron-btn-box">
            <button class="btn pull-right btn-jumbotron-right" type="button">
            </button>
          </div>
        </div>
      </div>
    </router-link>

    <div class="row align-items-md-stretch mb-4">
      <div class="col-md-6">
        <router-link to="/publications">
          <div class="h-80 p-5 hbtn-lightgray rounded-3 div-jumbotron hbtn-bg-2">
            <div class="col-10">
              <h1>Publications</h1>
              <p class="jmb-subtitle">Publications</p>
            </div>
            <div class="jumbotron-btn-box">
              <button class="btn pull-right btn-jumbotron-right" type="button">
              </button>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-md-6">
        <router-link to="/works">
          <div class="h-80 p-5 hbtn-lightgray rounded-3 div-jumbotron hbtn-bg-3">
            <div class="col-10">
              <h1>Works</h1>
              <p class="jmb-subtitle">Employments, Skills, Qualifications</p>
            </div>
            <div class="jumbotron-btn-box">
              <button class="btn pull-right btn-jumbotron-right" type="button">
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="row align-items-md-stretch mb-4">
      <div class="col-md-6">
        <router-link to="/experiences">
          <div class="h-80 p-5 hbtn-lightgray rounded-3 div-jumbotron hbtn-bg-4">
            <div class="col-10">
              <h1>Experiences</h1>
              <p class="jmb-subtitle">Projects, Activities, Awards</p>
            </div>
            <div class="jumbotron-btn-box">
              <button class="btn pull-right btn-jumbotron-right" type="button">
              </button>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6">
        <router-link to="/extras">
          <div class="h-80 p-5 hbtn-lightgray rounded-3 div-jumbotron hbtn-bg-5">
            <div class="col-10">
              <h1>ExtraInfo</h1>
              <p class="jmb-subtitle">More about Me!</p>
            </div>
            <div class="jumbotron-btn-box">
              <button class="btn pull-right btn-jumbotron-right" type="button">
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Homepage',
  components: {}
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue